import React, { Component } from 'react';
import { GenericEditPanel } from 'com-gyf-webcore-userinterfacecomponents';
import RubroExcepcionRadioButton from './Rubros/RubroExcepcionRadioButton.jsx';
import BuscadorRubros from './Rubros/BuscadorRubros.jsx';
import ListadoRubros from './Rubros/ListadoRubros.jsx';
import RubroTag from './Rubros/RubroTag.jsx';

class Rubros extends Component {
    constructor(props) {
        super(props)

        this.actualizarNovedadEstados = this.actualizarNovedadEstados.bind(this);

        this.filtroRubro = this.filtroRubro.bind(this);
        this.guardarNovedades = this.guardarNovedades.bind(this);
        this.generarNovedad = this.generarNovedad.bind(this);
    }
    /**
     * 
     * @param {any} novedades
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstados(estadoId, entidadId) {
        const novedades = this.props.data.novedadesEmpresaDatos.filter(x => x.NovedadCampoCodigo == "RUBEX_EMPR" || x.NovedadCampoCodigo == "RUBIN_EMPR");
        this.props.actualizarNovedadEstados(novedades, estadoId, novedades[0].NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} e
     */
    filtroRubro(e) {
        let typeInput = e.target.id;
        let isCheck = e.target.checked;
        this.props.filtroRubro(typeInput, isCheck);
    }
    /**
     * 
     */
    guardarNovedades() {
        let novedades = [
            { 'Id': undefined, 'Clave': 'RUBEX_EMPR', 'ValorAnterior': "", 'ValorNuevo': "" },
            { 'Id': undefined, 'Clave': 'RUBIN_EMPR', 'ValorAnterior': "", 'ValorNuevo': "" }
        ];
        switch (this.props.data.empresaDatosOriginal.RubroIncluidoExcluido) {
            case "E":
                novedades[0].ValorAnterior = this.generarNovedad(this.props.data.empresaDatosOriginal.rubros.filter(x => x.selected), true);
                //novedades[0].ValorAnterior = "";
                break;
            case "I":
                //novedades[0].ValorAnterior = "";
                novedades[1].ValorAnterior = this.generarNovedad(this.props.data.empresaDatosOriginal.rubros.filter(x => x.selected), true);
                break;
        }
        switch (this.props.data.empresaDatos.RubroIncluidoExcluido) {
            case "E":
                novedades[0].ValorNuevo = this.generarNovedad(this.props.data.empresaDatos.rubros.filter(x => x.selected), true);
                break;
            case "I":
                novedades[1].ValorNuevo = this.generarNovedad(this.props.data.empresaDatos.rubros.filter(x => x.selected), true);
                break;
        }

        this.props.guardarNovedades(novedades);
    }
    /**
     * 
     * @param {any} rubros
     * @param {any} codigo
     */
    generarNovedad(rubros, codigo) {
        let novedad = "";
        rubros.forEach(function (rubro) {
            novedad += codigo ? rubro.Codigo + "," : rubro.Descripcion + ",";
        });
        return novedad.slice(0, -1);
    }

    generarNovedadAnterior(rubros, codigo, valorAnterior) {
        let novedad = "";
        let novedades = valorAnterior.split(",");
        novedades.forEach(function (rc) {
            let rubro = rubros.find(x => x.Codigo == rc);
            novedad += codigo ? rubro.Codigo + "," : rubro.Descripcion + ",";
        });
        return novedad.slice(0, -1);
    }

    render() {
        let me = this;
        let props = this.props;

        //////////Novedad en Rubros////////////
        let seEstaEditando = props.data.seEstaEditando;
        let descripcion = undefined;
        let RubroIncluidoExcluido;
        let novedadRubros;
        let todosSelected;
        let solamenteSelected;
        let checkExcepto;
        let novedadRubrosExcepto = undefined;
        let novedadRubrosIncluido = undefined;

        RubroIncluidoExcluido = props.data.empresaDatos.RubroIncluidoExcluido;
        todosSelected = RubroIncluidoExcluido != "I" ? true : false;
        solamenteSelected = !todosSelected;
        checkExcepto = RubroIncluidoExcluido == "E" ? true : false;
        descripcion = RubroIncluidoExcluido == "E" ? "Excepto" : RubroIncluidoExcluido == "I" ? "Solamente" : "Todos";
        if (descripcion != "Todos") {
            descripcion += ": " + this.generarNovedad(this.props.data.empresaDatos.rubros.filter(x => x.selected), false);
        }
        if (props.data.novedadesEmpresaDatos != undefined) {
            novedadRubrosExcepto = props.data.novedadesEmpresaDatos.find(x => x.NovedadCampoCodigo == "RUBEX_EMPR");
            novedadRubrosIncluido = props.data.novedadesEmpresaDatos.find(x => x.NovedadCampoCodigo == "RUBIN_EMPR");

            if (novedadRubrosExcepto != undefined && novedadRubrosIncluido != undefined) {

                if (novedadRubrosExcepto.ValorAnterior == "" && novedadRubrosIncluido.ValorAnterior == "") {
                    novedadRubros = JSON.parse(JSON.stringify(novedadRubrosExcepto));
                    novedadRubros.ValorAnteriorFormateado = "Todos"
                }
                else {
                    let novedadesAnterior = "";
                    //TODOS EXCEPTO
                    if (novedadRubrosExcepto.ValorAnterior != "" && novedadRubrosIncluido.ValorAnterior == "") {
                        novedadesAnterior = this.generarNovedadAnterior(this.props.data.empresaDatosOriginal.rubros, false, novedadRubrosExcepto.ValorAnterior);

                        novedadRubros = JSON.parse(JSON.stringify(novedadRubrosExcepto));
                        novedadRubros.ValorAnterior = this.generarNovedadAnterior(this.props.data.empresaDatosOriginal.rubros, true, novedadRubrosExcepto.ValorAnterior);
                        novedadRubros.ValorAnteriorFormateado = "Excepto: " + novedadesAnterior;
                    }
                    else {
                        //TODOS SOLAMENTE
                        if (novedadRubrosExcepto.ValorAnterior == "" && novedadRubrosIncluido.ValorAnterior != "") {
                            novedadesAnterior = this.generarNovedadAnterior(this.props.data.empresaDatosOriginal.rubros, false, novedadRubrosIncluido.ValorAnterior);

                            novedadRubros = JSON.parse(JSON.stringify(novedadRubrosIncluido));
                            novedadRubros.ValorAnterior = this.generarNovedadAnterior(this.props.data.empresaDatosOriginal.rubros, true, novedadRubrosIncluido.ValorAnterior);
                            novedadRubros.ValorAnteriorFormateado = "Solamente: " + novedadesAnterior;
                        }
                    }
                }
                //}
            }
        }
        ////////////////////////////////////////////////////

        let rubros = this.props.data.empresaDatos.rubros.filter(x => !x.selected);
        let rubrosEmpresa = this.props.data.empresaDatos.rubros.filter(x => x.selected);
        let rubrosEmpresaOpt = rubros.map(function (rubro) {
            return (
                <option Id={rubro.Id} value={rubro.Descripcion} key={"Rubros_" + rubro.Id} />
            );
        });

        let rubrosList = [];
        if (rubrosEmpresa.length > 0) {
            rubrosList = rubrosEmpresa.map(function (row) {
                return (
                    <RubroTag
                        key={"Rubro" + row.Id}
                        Id={row.Id}
                        Descripcion={row.Descripcion}
                        changeRubro={me.props.changeRubro}
                    />
                );
            });
        }

        let componente = (
            <div>
                <div className="row top-separator-xs">
                    <div className={"col-xs-12 bottom-padding-xs " + (todosSelected ? "selected" : "")}>
                        <RubroExcepcionRadioButton
                            id="todos"
                            checked={todosSelected}
                            enabled={todosSelected}
                            value={"T"}
                            filtroRubro={this.filtroRubro}
                            title="Todos" />
                        <div className="row">
                            <div className="col-xs-12">
                                <ul className="no-bullets no-padding no-margin">
                                    <li className="inlineListItem2 lg-margin">
                                        <div className="default-checkbox">
                                            <input
                                                id="todosExcepto"
                                                type="checkbox"
                                                checked={checkExcepto}
                                                enabled={todosSelected}
                                                onChange={this.filtroRubro} />
                                            <label htmlFor="todosExcepto"></label>
                                        </div>
                                    </li>
                                    <li className="inlineListItem2">
                                        <label className="label-secondary" htmlFor="todosExcepto">Excepto</label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <BuscadorRubros
                            idBuscador="inputAllExcept"
                            idLista="listRubrosExcept"
                            placeholder="Buscar rubros para excluir"
                            disabled={!checkExcepto}
                            value={todosSelected ? this.props.data.valueBuscador : ""}
                            rubros={rubrosEmpresaOpt}
                            changeRubro={this.props.changeRubro} />
                        <ListadoRubros rubrosList={todosSelected ? rubrosList : []} />
                    </div>
                </div>
                <div className="row top-separator-xs">
                    <div className={"col-xs-12 bottom-padding-xs " + (solamenteSelected ? "selected" : "")}>
                        <RubroExcepcionRadioButton
                            id="solamente"
                            checked={solamenteSelected}
                            enabled={solamenteSelected}
                            value={"I"}
                            filtroRubro={this.filtroRubro}
                            title="Solamente" />
                        <BuscadorRubros
                            idBuscador="inputOnly"
                            idLista="listRubrosOnly"
                            placeholder="Buscar rubros para incluir"
                            disabled={!solamenteSelected}
                            value={solamenteSelected ? this.props.data.valueBuscador : ""}
                            changeRubro={this.props.changeRubro}
                            rubros={rubrosEmpresaOpt} />
                        <ListadoRubros rubrosList={solamenteSelected ? rubrosList : []} />
                    </div>
                </div>
            </div>
        );

        const validacionRubrosSolamente = (solamenteSelected == true && rubrosEmpresa.length == 0);

        return (
            <div>
                <GenericEditPanel
                    componente={componente}
                    error={validacionRubrosSolamente}
                    permisoUsuario={props.data.funcionesDelUsuario}
                    novedad={novedadRubros}
                    seEstaEditando={seEstaEditando}
                    textPanel={descripcion || "Sin especificar"}
                    title="Rubros en los que puede comprar"
                    value={this.generarNovedad(rubrosEmpresa, true)}

                    aceptChanges={this.guardarNovedades}
                    confirmarNovedad={() => this.actualizarNovedadEstados(2, props.data.empresaDatos.Id)}
                    changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                    denegarNovedad={() => this.actualizarNovedadEstados(3, props.data.empresaDatos.Id)}
                    mostrarModificaciones={this.props.mostrarModal}
                    revert={this.props.cancelar}
                />
                {validacionRubrosSolamente &&
                    < div className="row">
                        <div className="col-md-12">
                            <label className="error">Debe seleccionar al menos un rubro.</label>
                        </div>
                    </div>}
            </div>
        );
    }
}

export default Rubros;